import { KyInstance } from 'ky';

import { IReqOrders } from '@/types/fulfill/inventoryHistory';
import { handleRequest } from '@/utils/httpUtils';

import {
  Labels,
  LabelsAsync,
  LabelsAsyncResponse,
  LabelsPollJob,
  LabelsPollJobResponse,
  LabelsResponse,
  OrderById,
  OrderByIdResponse,
  Orders,
  OrdersResponse,
  ResumePO,
  ResumePOResponse,
  SkuLabels,
  SkuLabelsResponse,
} from './types';

export interface IReqHistoryOrders {
  orders: Orders;
  orderById: OrderById;
  skuLabels: SkuLabels;
  labels: Labels;
  resumePO: ResumePO;
  labelsAsync: LabelsAsync;
  labelsPollJob: LabelsPollJob;
}

export function reqHistoryOrders(http: KyInstance): IReqHistoryOrders {
  const route = 'api/v1';
  return {
    orders: ({ status, inventoryStatus, ...ars }: IReqOrders) => {
      const queryParams = buildRouteParamsFF(ars, [status!, inventoryStatus!]);
      return handleRequest<OrdersResponse>(http, 'get', `${route}/arrival-orders${queryParams}`);
    },
    orderById: (orderId: string, expand?: string) => {
      const query = expand ? `?expand=${expand}` : '';
      return handleRequest<OrderByIdResponse>(
        http,
        'get',
        `${route}/arrival-orders/${orderId}${query}`,
      );
    },
    skuLabels: ({ apiKey, legacyId }) =>
      handleRequest<SkuLabelsResponse>(http, 'post', 'labels/v2/po/products', {
        json: { legacyId },
        headers: { Authorization: `Bearer ${apiKey}` },
      }),
    labels: ({ apiKey, arrivalOrderNumber }) =>
      handleRequest<LabelsResponse>(http, 'post', 'labels/po', {
        json: { arrivalOrderNumber },
        headers: { Authorization: `Bearer ${apiKey}` },
      }),
    resumePO: ({ apiKey, arrivalOrderNumber }) =>
      handleRequest<ResumePOResponse>(http, 'post', 'labels/po/resume', {
        json: { arrivalOrderNumber },
        headers: { Authorization: `Bearer ${apiKey}` },
      }),
    labelsAsync: ({ apiKey, arrivalOrderNumber }) =>
      handleRequest<LabelsAsyncResponse>(http, 'post', 'labels/po/async', {
        json: { arrivalOrderNumber },
        headers: { Authorization: `Bearer ${apiKey}` },
      }),
    labelsPollJob: ({ apiKey, jobId }) =>
      handleRequest<LabelsPollJobResponse>(http, 'get', `labels/po/async/${jobId}`, {
        headers: { Authorization: `Bearer ${apiKey}` },
      }),
  };
}

const buildRouteParamsFF = (
  ars: Record<string, string | number | boolean | undefined>,
  filters?: string[],
) => {
  let route = '?';
  Object.entries(ars).forEach(([key, value]) => {
    const validation = value !== undefined && value !== null && value !== '';
    if (validation) {
      route += route.length > 1 ? `&${key}=${value}` : `${key}=${value}`;
    }
  });
  if (filters && filters.length > 0) {
    filters.forEach((filter) => {
      if (filter.length > 0) {
        route += route.length > 1 ? `&${filter}` : `${filter}`;
      }
    });
  }
  return route;
};
